<script>
export default {
    name: "AppTabCollapse",
    mounted() {
        let components = this.$slots.default.filter((vnode) => vnode.tag !== undefined)

        // set the default layout
        let defaultOrder = 1
        this.$store.dispatch(
            "appTabLayout/setDefaultLayout",
            components.map((component) => {
                return {
                    title: component.data.attrs.title,
                    name: component.data.attrs.name,
                    order: defaultOrder++,
                }
            })
        )

        // get the ordered components
        let orderedComponents = this.orderedComponents()

        // set all collapse items to be open on load
        this.$bus.$on('open-app-collapsed-section', data => {
            this.activeItems = data
        })

        this.activeItems = orderedComponents.map((component) => (Ambition.getGlobal('tenant.user.user_settings.expand_application_tabs') == 'no') ? '' : component.data.attrs.name)

        // store the layout in the store
        this.$store.dispatch(
            "appTabLayout/setLayout",
            orderedComponents.map((component) => {
                return {
                    title: component.data.attrs.title,
                    name: component.data.attrs.name,
                    order: component.order,
                }
            })
        )

        // store the sidebar layout in the store
        this.$store.dispatch(
            "appTabLayout/setSidebar",
            orderedComponents.map((component) => {
                return {
                    title: component.data.attrs.title,
                    name: component.data.attrs.name,
                    order: component.order,
                }
            })
        )
    },
    beforeDestroy() {
        this.$bus.$off('open-app-collapsed-section')
    },
    methods: {
        // get the order for a component
        order(name) {
            if (this.isCommercial) {
                return _.get(
                    _.get(this.userSettings, "commercialLayout", []).find((layout) => layout.name == name),
                    "order",
                    -1
                )
            } else {
                return _.get(
                    _.get(this.userSettings, "consumerLayout", []).find((layout) => layout.name == name),
                    "order",
                    -1
                )
            }
        },
        orderedComponents() {
            // get the components
            let components = this.$slots.default.filter((vnode) => vnode.tag !== undefined)

            // inject the order
            components.forEach((component, key) => {
                Vue.set(components[key], "order", this.order(component.data.attrs.name))
            })
            
            // return the ordered components
            return _.sortBy(components, "order")
        },
    },
    computed: {
        // get the logged in user settings
        userSettings() {
            return this.$store.getters["user/settings"]
        },
        // check to see if this application is a commercial app
        isCommercial() {
            return this.$store.getters.initAppData.application_type_id == 2 ? true : false
        },
        // get and set active collapse items
        activeItems: {
            get() {
                return this.$store.getters["appTabLayout/getActiveItems"]
            },
            set(item) {
                this.$store.dispatch("appTabLayout/setActiveItems", item)
            },
        },
    },
    render(createElement) {
        // render the components
        return createElement(
            "el-collapse",
            {
                class: "app-tab-collapse",
                props: {...this.$props, value: this.activeItems},
                attrs: {...this.$attrs},
                on: {
                    input: (value) => {
                        this.activeItems = value
                    },
                },
            },
            this.orderedComponents()
        )
    },
}
</script>
